import {useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetMyStoreTicketRecord = (prefix = '') => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [searchParams] = useSearchParams()
	const getParamName = (paramName) =>
		prefix ? `${prefix}_${paramName}` : paramName

	const page = searchParams.get(getParamName('page'))
	const search = searchParams.get(getParamName('search'))
	const recordType = searchParams.get(getParamName('voucherType'))
	const sortBy = searchParams.get(getParamName('sortBy'))
	const sortDirection = searchParams.get(getParamName('sortDirection'))

	const [, setAlert] = useAlertModalAtom()

	const [userRole] = useRoleCookie()
	const rolePath = getApiRolePath(userRole)

	useEffect(() => {
		let url = `/${rolePath}/store/my/ticket/record?page=${page || 1}`

		if (search) url += `&search=${search}`
		if (recordType && recordType !== 'all') url += `&recordType=${recordType}`
		if (sortBy) url += `&sortBy=${sortBy}`
		if (sortDirection) url += `&sortDirection=${sortDirection}`

		fetchRequest('GET', url)
	}, [page, search, recordType, sortBy, sortDirection])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'page')
					setAlert('페이지 번호를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			default:
				break
		}
	}, [fetchResult])

	return [fetchResult, isLoading]
}

export default useGetMyStoreTicketRecord
